export const version = "1.0.2-daily-20250828-0";
export const channel = "daily";
export const gitcommit = "a86862e19";
